export default __webpack_public_path__ + "static/media/imageNews.23580be4.png";